import React from 'react'
import { useSelector } from 'react-redux'
import PageResult from '../../../features/search/components/page-result'
import { Featured } from '../../blog/components'

const DetailBlog = () => {
  const defaultFeatureds = useSelector(state => state.organization.featured_blogs)

  return (
    <PageResult
      customHeader={<></>}
      customNav={<Featured embed={true} defaultItems={defaultFeatureds}/>}
      filterOptions={{
        keyword: true,
        location: false,
        type: true,
        date: true,
        category: true,
        category_resource: false,
        type_resource: false,
      }}
    />
  )
}

export { DetailBlog }
